import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import TrademarkText from '../../ui/TrademarkText'
import { ReactComponent as Dashboards } from '../../../assets/imgs/overview/dashboards_graphic.svg'

const WorkforceInsights = () => {
  return (
    <section className='overview-section workforce-insights-section'>
      <div className='box'>
        <div className='workforce-insights-grid'>
          <div className='workforce-insights-content'>
            <h2 className='workforce-insights-title'>
              Turn Workforce Insights Into Strategic Decisions
            </h2>
            <div className='workforce-insights-labels' aria-label='Insight topics'>
              <span className='workforce-insights-label'>Skills Intelligence</span>
              <span className='workforce-insights-label'>Workforce Gaps</span>
              <span className='workforce-insights-label'>Demand vs Supply</span>
            </div>
            <p className='workforce-insights-copy'>
              Real-time dashboards powered by <TrademarkText>Pod Intelligence Core™</TrademarkText>{' '}
              and <TrademarkText>Pod Atlas™</TrademarkText> provide comprehensive
              visibility into skills distribution, workforce trends, demand
              versus supply gaps, and emerging capability risks.
            </p>
            <p className='workforce-insights-copy'>
              These intelligence dashboards enable executives, HR leaders, and
              strategic planners to make informed, data-driven workforce
              decisions with confidence.
            </p>
          </div>

          <div className='workforce-insights-visual overview-tile-container dark-background box-relative-gradient'>
            <Dashboards className='elements' />
          </div>
        </div>
      </div>
    </section>
  )
}

export default WorkforceInsights
